import { WindowTitle } from "@saleor/components/WindowTitle";
// import { InstagramPathUrlQueryParams } from "@saleor/shipment/urls";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import {
  shipmentListPath,
  shipmentListUrlQueryParams,
  shipmentListUrlSortField,
  shipmentPath,
  shipmentPathUrlQueryParams
} from "./urls";
import ShipmentDetailsComponent from "./views/ShipmentDetails";
import ShipmentListComponent from "./views/ShipmentList";

const ShipmentList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: shipmentListUrlQueryParams = asSortParams(
    qs,
    shipmentListUrlSortField
  );
  return <ShipmentListComponent params={params} />;
};

const ShipmentDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: shipmentPathUrlQueryParams = qs;
  return (
    <ShipmentDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

export const ShipmentSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.shipment)} />
      <Switch>
        <Route exact path={shipmentListPath} component={ShipmentList} />
        <Route path={shipmentPath(":id")} component={ShipmentDetails} />
      </Switch>
    </>
  );
};

export default ShipmentSection;
